import { searchRetryConfig } from '@/lib/http/searchRequests';

import kinetikApi from './kinetikAPI';

export default {
  getTrips: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/trips`, { ...options, serviceName: 'trip' })
      .then((res) => res.data),
  searchTrips: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/trips/search`, {
        ...searchRetryConfig,
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  getItineraries: (orgId, options, viewType = 'full') =>
    kinetikApi
      .get(`/${orgId}/trips/itinerary-view/${viewType}`, {
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  // A read despite the POST, so it retries like the searches.
  getTripsGroupByView: (orgId, body, viewType = 'full') =>
    kinetikApi
      .post(`/${orgId}/trips/group-by-view/${viewType}`, body, {
        ...searchRetryConfig,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  searchTripsGroupByView: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/trips/search/group-by-view`, {
        ...searchRetryConfig,
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  getEvents: (orgId, uuid, options) =>
    kinetikApi
      .get(`/${orgId}/trips/t/${uuid}/events`, {
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  getCsv: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/trips/csv`, { ...options, serviceName: 'trip' })
      .then((res) => res.data),
  createItinerary: (orgId, tripType, body) =>
    kinetikApi
      .post(`/${orgId}/trips/itinerary/${tripType}`, body, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  createRecurringItinerary: (orgId, body) =>
    kinetikApi
      .post(`/${orgId}/trips/recurring`, body, { serviceName: 'trip' })
      .then((res) => res.data),

  getUberEstimates: (body) =>
    kinetikApi
      .post('/proxy/uber-health/trips/estimates', body, {
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getLyftEstimates: (params) =>
    kinetikApi
      .get('/proxy/lyft/v1/cost', { ...params, serviceName: 'proxy' })
      .then((res) => res.data),
  patchTrip: (orgId, tripUuid, body) =>
    kinetikApi
      .patch(`/${orgId}/trips/t/${tripUuid}`, body, { serviceName: 'trip' })
      .then((res) => res.data),
  addRequesterNote: (orgId, tripUuid, body) =>
    kinetikApi
      .post(`/${orgId}/trips/t/${tripUuid}/requester-notes`, body, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  updateRequesterNote: (orgId, tripUuid, noteUuid, body) =>
    kinetikApi
      .patch(
        `/${orgId}/trips/t/${tripUuid}/requester-notes/${noteUuid}`,
        body,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  deleteRequesterNote: (orgId, tripUuid, noteUuid) =>
    kinetikApi
      .delete(`/${orgId}/trips/t/${tripUuid}/requester-notes/${noteUuid}`, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  getComputedAssignmentCandidates: (orgId, tripId, options = {}) =>
    kinetikApi
      .get(
        `/${orgId}/assignment/compute-assignment-candidates-for-trip/${tripId}?mode=lax`,
        { ...options, serviceName: 'trip' },
      )
      .then((res) => res.data),
  bulkAssignTrips: (
    orgId,
    tripsIdentifierKey,
    tripIdentifierValue,
    contractUuid,
    tripType,
    body = {},
  ) =>
    kinetikApi
      .post(
        `/${orgId}/assignment/bulk/${tripsIdentifierKey}/${tripIdentifierValue}/${tripType}/via-contract/${
          contractUuid ?? 'UNSPECIFIED'
        }`,
        body,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  unassignTrip: (orgId, tripUuid, body) =>
    kinetikApi
      .patch(`/${orgId}/trips/t/${tripUuid}/unassign`, body, {
        serviceName: 'trip',
      })
      .then((res) => res.data),

  postAssignedTripRevision: (orgId, tripUuid, body) =>
    kinetikApi
      .post(`/${orgId}/trips/t/${tripUuid}/trip-revision/assigned`, body, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  deleteAssignedTripRevision: (orgId, tripUuid) =>
    kinetikApi
      .delete(`/${orgId}/trips/t/${tripUuid}/trip-revision`, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  applyAssignedTripRevisionUpdates: (orgId, tripUuid, body) =>
    kinetikApi
      .patch(
        `/${orgId}/trips/t/${tripUuid}/trip-revision/assigned/apply`,
        body,
        {
          serviceName: 'trip',
        },
      )
      .then((res) => res.data),
  getRecomputedAssignmentCandidatesForRevisionUpdate: (orgId, tripUuid) =>
    kinetikApi
      .post(
        `/${orgId}/assignment/recompute-candidates-for-assigned-trip-revision/${tripUuid}`,
        undefined,
        {
          serviceName: 'trip',
        },
      )
      .then((res) => res.data),
  getJobs: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/trip-jobs`, {
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  makeApprovalDecision: (
    orgId,
    tripType,
    tripsIdentifierKey,
    tripIdentifierValue,
    decision,
    body,
  ) =>
    kinetikApi
      .post(
        `/${orgId}/trips/make-approval-decision/${tripType}/${tripsIdentifierKey}/${tripIdentifierValue}/${decision}`,
        body,
        {
          serviceName: 'trip',
        },
      )
      .then((res) => res.data),
  searchRecurringItineraries: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/trips/recurring/itineraries/search`, {
        ...searchRetryConfig,
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  bulkTerminateTrips: (orgId, action, body) =>
    kinetikApi
      .patch(`/${orgId}/trips/bulk-terminate/${action}`, body, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  // TS-8641 — PHC denial / notice letters. Jobified: returns { jobUuid }.
  generateLetters: (orgId, letterType, body) =>
    kinetikApi
      .post(`/${orgId}/trips/generate-letters/${letterType}`, body, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  // Presigned S3 URL for the finished job's zip archive.
  getLetterJobArchive: (orgId, jobUuid) =>
    kinetikApi
      .get(`/${orgId}/trips/letter-jobs/${jobUuid}/archive`, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  bulkUpdateTrips: (orgId, body) =>
    kinetikApi
      .patch(`/${orgId}/trips/bulk-update`, body, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  assignMileageTrips: (orgId, itineraryUuid, body) =>
    kinetikApi
      .post(
        `/${orgId}/assignment/mileage-reimbursement/itinerary/${itineraryUuid}`,
        body,
        {
          serviceName: 'trip',
        },
      )
      .then((res) => res.data),
  getTripVehiclePositionHistory: (orgId, tripUuid) =>
    kinetikApi
      .get(`/${orgId}/trips/t/${tripUuid}/vehicle-position-history`, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  completeTrips: (orgId, itineraryUuid, tripType, body) =>
    kinetikApi
      .post(
        `${orgId}/trips/mark-itinerary-as-complete/${tripType}/${itineraryUuid}`,
        body,
        {
          serviceName: 'trip',
        },
      )
      .then((res) => res.data),
  updateTripLabels: (orgResourceId, tripUuid, payload) =>
    kinetikApi
      .patch(
        `/${orgResourceId}/trips/update-labels/uuid/${tripUuid}`,
        payload,
        {
          serviceName: 'trip',
        },
      )
      .then((res) => res.data),
  markProviderNoShow: (orgId, tripUuid) =>
    kinetikApi
      .post(
        `/${orgId}/dispatch/trips/${tripUuid}/mark-provider-no-show`,
        undefined,
        {
          serviceName: 'trip',
        },
      )
      .then((res) => res.data),
  getTripsCounts: (orgId, body) =>
    kinetikApi
      .post(`/${orgId}/trips/counts`, body, { serviceName: 'trip' })
      .then((res) => res.data),
};
